const ui = {
  en: {
    // Generic / reusable
    loading: 'Loading…',
    retry: 'Retry',
    retrying: 'Retrying…',
    cancel: 'Cancel',
    delete: 'Delete',
    close: 'Close',
    edit: 'Edit',
    previous: 'Previous',
    next: 'Next',
    selectPlaceholder: 'Select…',
    noDataAvailable: 'No data available',

    // Shared primitives: date / time pickers, dialogs, error state, table scroll
    datePickerPlaceholder: 'Pick a date...',
    datePickerClear: 'Clear',
    datePickerToday: 'Today',
    datePickerPrevMonth: 'Previous month',
    datePickerNextMonth: 'Next month',
    timePickerPlaceholder: 'Pick a time...',
    timePickerHours: 'Hours',
    timePickerMinutes: 'Minutes',
    timePickerNow: 'Now',
    rangeFromAria: 'Start date',
    rangeToAria: 'End date',
    rangeToday: 'Today',
    rangeLastDays: '{count} days',
    confirmTitle: 'Are you sure?',
    confirmAction: 'Confirm',
    errorTitle: 'Something went wrong',
    errorDescription: 'Please try again.',
    retryAgain: 'Try again',
    clearSearch: 'Clear search',
    forbiddenTitle: 'No access',
    forbiddenDescription: 'Your role does not have access to this page.',

    // FilterSheet, PageHead, ProgressBar
    filters: 'Filters',
    filtersActive: '{count} active',
    filtersReset: 'Clear filters',
    filtersDone: 'Done',
    back: 'Back',
    progress: 'Progress',

    // FormErrorDisplay
    connectionLost: 'Connection lost',
    somethingWentWrong: 'Something went wrong',
    willRetryWhenOnline: 'Will automatically retry when your connection is restored.',
    retryingIn: 'Retrying in {seconds}s...',
    maxRetriesReached: 'Maximum retry attempts reached. Please try again later.',

    // FormErrorBoundary
    unexpectedRequestError: 'An unexpected error occurred while processing your request. Please try again.',
    errorDetailsDev: 'Error details (Development only)',
    retryAttempt: 'Retry attempt {count}',

    // RiskScoreTrendChart
    loadingTrendData: 'Loading trend data...',
    notEnoughTrendData: 'Not enough data yet for a trend chart.',
    riskScoreLabel: 'Risk score:',
    triggerLabel: 'Trigger:',

    // ComingSoon
    comingSoonDefaultDesc: 'This feature is under development and will be available soon.',
    comingSoonBadge: 'Coming soon',
    offlineEventsTitle: 'Offline events',
    offlineEventsDescription: 'Schedule and manage in-person events, workshops, and classes.',

    // SearchableCourseSelect
    searchCoursesPlaceholder: 'Search courses...',
    noCoursesFound: 'No courses found',
    loadMoreCourses: 'Load more courses',
    coursesLoadFailed: 'Could not load the course list.',

    // SearchableDropdown
    selectOptionPlaceholder: 'Select an option...',
    searchPlaceholder: 'Search...',
    searchOptionsAria: 'Search options',
    noOptionsFound: 'No options found',
    loadMoreItems: 'Load more items...',
    loadingMore: 'Loading more...',

    // Pagination
    pageOfTotal: 'Page {page} of {total}',
    totalCount: '{count} total',
    paginationRange: '{start}–{end} of {total}',

    // Course level (SearchableCourseSelect, CourseOverview)
    levelBeginner: 'Beginner',
    levelIntermediate: 'Intermediate',
    levelAdvanced: 'Advanced',
  },
  ru: {
    // Generic / reusable
    loading: 'Загрузка…',
    retry: 'Повторить',
    retrying: 'Повтор…',
    cancel: 'Отмена',
    delete: 'Удалить',
    close: 'Закрыть',
    edit: 'Изменить',
    previous: 'Назад',
    next: 'Далее',
    selectPlaceholder: 'Выбрать…',
    noDataAvailable: 'Нет данных',

    // Shared primitives: date / time pickers, dialogs, error state, table scroll
    datePickerPlaceholder: 'Выберите дату...',
    datePickerClear: 'Очистить',
    datePickerToday: 'Сегодня',
    datePickerPrevMonth: 'Предыдущий месяц',
    datePickerNextMonth: 'Следующий месяц',
    timePickerPlaceholder: 'Выберите время...',
    timePickerHours: 'Часы',
    timePickerMinutes: 'Минуты',
    timePickerNow: 'Сейчас',
    rangeFromAria: 'Дата начала',
    rangeToAria: 'Дата окончания',
    rangeToday: 'Сегодня',
    rangeLastDays: '{count} дн.',
    confirmTitle: 'Вы уверены?',
    confirmAction: 'Подтвердить',
    errorTitle: 'Произошла ошибка',
    errorDescription: 'Пожалуйста, попробуйте ещё раз.',
    retryAgain: 'Повторить',
    clearSearch: 'Очистить поиск',
    forbiddenTitle: 'Нет доступа',
    forbiddenDescription: 'У вашей роли нет доступа к этой странице.',

    // FilterSheet, PageHead, ProgressBar
    filters: 'Фильтры',
    filtersActive: 'активно: {count}',
    filtersReset: 'Сбросить фильтры',
    filtersDone: 'Готово',
    back: 'Назад',
    progress: 'Прогресс',

    // FormErrorDisplay
    connectionLost: 'Нет соединения',
    somethingWentWrong: 'Что-то пошло не так',
    willRetryWhenOnline: 'Повтор произойдёт автоматически, когда соединение восстановится.',
    retryingIn: 'Повтор через {seconds} с...',
    maxRetriesReached: 'Достигнуто максимальное количество попыток. Повторите позже.',

    // FormErrorBoundary
    unexpectedRequestError: 'При обработке запроса произошла непредвиденная ошибка. Попробуйте ещё раз.',
    errorDetailsDev: 'Детали ошибки (только для разработки)',
    retryAttempt: 'Попытка повтора {count}',

    // RiskScoreTrendChart
    loadingTrendData: 'Загрузка данных тренда...',
    notEnoughTrendData: 'Пока недостаточно данных для графика тренда.',
    riskScoreLabel: 'Оценка риска:',
    triggerLabel: 'Триггер:',

    // ComingSoon
    comingSoonDefaultDesc: 'Эта функция находится в разработке и скоро будет доступна.',
    comingSoonBadge: 'Скоро',
    offlineEventsTitle: 'Офлайн-мероприятия',
    offlineEventsDescription: 'Планируйте и управляйте очными мероприятиями, мастер-классами и занятиями.',

    // SearchableCourseSelect
    searchCoursesPlaceholder: 'Поиск курсов...',
    noCoursesFound: 'Курсы не найдены',
    loadMoreCourses: 'Загрузить ещё курсы',
    coursesLoadFailed: 'Не удалось загрузить список курсов.',

    // SearchableDropdown
    selectOptionPlaceholder: 'Выберите вариант...',
    searchPlaceholder: 'Поиск...',
    searchOptionsAria: 'Поиск вариантов',
    noOptionsFound: 'Варианты не найдены',
    loadMoreItems: 'Загрузить ещё...',
    loadingMore: 'Загрузка ещё...',

    // Pagination
    pageOfTotal: 'Страница {page} из {total}',
    totalCount: 'всего {count}',
    paginationRange: '{start}–{end} из {total}',

    // Course level (SearchableCourseSelect, CourseOverview)
    levelBeginner: 'Начинающий',
    levelIntermediate: 'Средний',
    levelAdvanced: 'Продвинутый',
  },
  uz: {
    // Generic / reusable
    loading: 'Yuklanmoqda…',
    retry: 'Qayta urinish',
    retrying: 'Qayta urinilmoqda…',
    cancel: 'Bekor qilish',
    delete: "O'chirish",
    close: 'Yopish',
    edit: 'Tahrirlash',
    previous: 'Oldingi',
    next: 'Keyingi',
    selectPlaceholder: 'Tanlang…',
    noDataAvailable: "Ma'lumot yo'q",

    // Shared primitives: date / time pickers, dialogs, error state, table scroll
    datePickerPlaceholder: 'Sanani tanlang...',
    datePickerClear: 'Tozalash',
    datePickerToday: 'Bugun',
    datePickerPrevMonth: 'Oldingi oy',
    datePickerNextMonth: 'Keyingi oy',
    timePickerPlaceholder: 'Vaqtni tanlang...',
    timePickerHours: 'Soat',
    timePickerMinutes: 'Daqiqa',
    timePickerNow: 'Hozir',
    rangeFromAria: 'Boshlanish sanasi',
    rangeToAria: 'Tugash sanasi',
    rangeToday: 'Bugun',
    rangeLastDays: '{count} kun',
    confirmTitle: 'Ishonchingiz komilmi?',
    confirmAction: 'Tasdiqlash',
    errorTitle: 'Xatolik yuz berdi',
    errorDescription: "Iltimos, qaytadan urinib ko'ring.",
    retryAgain: 'Qaytadan',
    clearSearch: 'Qidiruvni tozalash',
    forbiddenTitle: "Ruxsat yo'q",
    forbiddenDescription: "Sizning rolingiz bu sahifaga kira olmaydi.",

    // FilterSheet, PageHead, ProgressBar
    filters: 'Filtrlar',
    filtersActive: '{count} ta faol',
    filtersReset: 'Filtrlarni tozalash',
    filtersDone: 'Tayyor',
    back: 'Orqaga',
    progress: 'Progress',

    // FormErrorDisplay
    connectionLost: 'Aloqa uzildi',
    somethingWentWrong: 'Nimadir xato ketdi',
    willRetryWhenOnline: "Aloqa tiklanganda avtomatik ravishda qayta urinib ko'riladi.",
    retryingIn: '{seconds} soniyadan keyin qayta urinish...',
    maxRetriesReached: "Urinishlar soni tugadi. Keyinroq qayta urinib ko'ring.",

    // FormErrorBoundary
    unexpectedRequestError: "Kutilmagan xatolik yuz berdi. Qayta urinib ko'ring.",
    errorDetailsDev: 'Xato tafsilotlari (faqat ishlab chiqish uchun)',
    retryAttempt: 'Qayta urinish {count}',

    // RiskScoreTrendChart
    loadingTrendData: "Trend ma'lumotlari yuklanmoqda...",
    notEnoughTrendData: "Trend grafigi uchun hali yetarli ma'lumot yo'q.",
    riskScoreLabel: 'Xavf balli:',
    triggerLabel: 'Trigger:',

    // ComingSoon
    comingSoonDefaultDesc: "Bu funksiya ishlab chiqilmoqda va tez orada mavjud bo'ladi.",
    comingSoonBadge: 'Tez kunda',
    offlineEventsTitle: 'Oflayn tadbirlar',
    offlineEventsDescription: "Yuzma-yuz tadbirlar, seminarlar va darslarni rejalashtiring va boshqaring.",

    // SearchableCourseSelect
    searchCoursesPlaceholder: 'Kurslarni qidirish...',
    noCoursesFound: 'Kurslar topilmadi',
    loadMoreCourses: 'Yana kurslarni yuklash',
    coursesLoadFailed: "Kurslar ro'yxatini yuklab bo'lmadi.",

    // SearchableDropdown
    selectOptionPlaceholder: 'Variantni tanlang...',
    searchPlaceholder: 'Qidirish...',
    searchOptionsAria: 'Variantlarni qidirish',
    noOptionsFound: 'Variantlar topilmadi',
    loadMoreItems: 'Yana yuklash...',
    loadingMore: 'Yana yuklanmoqda...',

    // Pagination
    pageOfTotal: '{page}-sahifa, jami {total}',
    totalCount: 'jami {count}',
    paginationRange: '{start}–{end} / jami {total}',

    // Course level (SearchableCourseSelect, CourseOverview)
    levelBeginner: "Boshlang'ich",
    levelIntermediate: "O'rta",
    levelAdvanced: 'Yuqori',
  },
};

export default ui;
